import { FC, useEffect, useState } from 'react';
import { useParams, useLoaderData } from 'react-router-dom';

import { ContentLoading } from '../../../../shared/components/loading/loading.component';
import { TabPanel } from '../../../../shared/components/tabs';
import { TMode, modeService } from '../../../../shared/services/mode/mode.service';
import { CustomerTabs, ITabState } from '../../states/tabState.model';
import { TabContentContainer } from '../../../../shared/components/tabs/tabsContainer.component.tsx';
import { FormsTab } from './forms/forms.tab.tsx';
import { customerTabLoadingService } from './customerTabLoading.service.ts';
import { Lists } from './lists/lists.tab.tsx';
import { Tour } from './tour/tour.tab.tsx';
import { Availability } from './availability/availability.tab.tsx';
import { CashAssist } from './cashAssist/cashAssist.tab.tsx';
import { DefaultOrder } from './defaultOrder/defaultOrder.tab.tsx';
import { ConditionsTab } from './conditions/conditions.tab.tsx';
import { GeneralModeContainer } from './general/generalModeContainer.tsx';
import { customersListState } from '../../states/customersList.state.ts';
import { Bakery2b } from './bakery2b/bakery2b.tab.tsx';
import { Crm } from './crm/crm.tab.tsx';
import { Box } from '@mui/material';

const CustomerDetails: FC = () => {
  const { tab } = useParams() as { tab: CustomerTabs };
  const {
    defaultValues: { informationTip },
  } = useLoaderData() as ITabState;

  const [loading, setLoading] = useState<boolean>(false);
  const [mode, setMode] = useState<TMode>('edit');

  useEffect(() => {
    customersListState.pub.updateInfoTip(informationTip);
    const unsubLoading = customerTabLoadingService.sub.loading().subscribe((v) => {
      setLoading(v.isLoading);
    });
    const unsubMode = modeService.sub.mode().subscribe(setMode);

    return () => {
      modeService.pub.mode('edit');

      unsubMode.unsubscribe();
      unsubLoading.unsubscribe();
    };
  }, []);

  return (
    <TabContentContainer>
      <Box sx={{ flexGrow: 1 }}>
        <ContentLoading loading={loading}>
          {tab === CustomerTabs.general && <GeneralModeContainer mode={mode} tab={tab} />}

          {mode === 'edit' && (
            <>
              <TabPanel value={CustomerTabs.forms} activeValue={tab}>
                <FormsTab />
              </TabPanel>
              <TabPanel value={CustomerTabs.lists} activeValue={tab}>
                <Lists />
              </TabPanel>
              <TabPanel value={CustomerTabs.availability} activeValue={tab}>
                <Availability />
              </TabPanel>
              <TabPanel value={CustomerTabs.tour} activeValue={tab}>
                <Tour />
              </TabPanel>
              <TabPanel value={CustomerTabs.cashAssist} activeValue={tab}>
                <CashAssist />
              </TabPanel>
              <TabPanel value={CustomerTabs.defaultOrder} activeValue={tab}>
                <DefaultOrder />
              </TabPanel>
              <TabPanel value={CustomerTabs.conditions} activeValue={tab}>
                <ConditionsTab />
              </TabPanel>
              <TabPanel value={CustomerTabs.bakery2b} activeValue={tab}>
                <Bakery2b />
              </TabPanel>
              <TabPanel value={CustomerTabs.crm} activeValue={tab}>
                <Crm />
              </TabPanel>
            </>
          )}
        </ContentLoading>
      </Box>
    </TabContentContainer>
  );
};
export default CustomerDetails;
